import React, { useEffect, useState } from "react";
import "./Exhibition.css";
import {
  Button,
  Modal,
  Pagination,
  Table,
  message,
  Input,
  Form,
  Select,
  DatePicker,
  Upload,
} from "antd";
import { get, post } from "../../apiService";
import { UploadOutlined } from "@ant-design/icons";
import moment from "moment";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // import styles for react-quill
import { getProfile } from "../../services/localStorageServices";
import TitleComp from "./TitleComp";
import { FaEdit } from "react-icons/fa";
import { FaTrashAlt } from "react-icons/fa";

const { confirm } = Modal;
const { Option } = Select;

const Exhibition = () => {
  const [allquote, setAllQuote] = useState([]);
  const { profile } = getProfile();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [loading, setLoading] = useState(false);
  const [isUpdateModalVisible, setIsUpdateModalVisible] = useState(false);
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [selectedExhibition, setSelectedExhibition] = useState(null);
  const [updateForm] = Form.useForm();
  const [addForm] = Form.useForm();
  const [searchInput, setSearchInput] = useState("");

  const columns = [
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      render: (image) =>
        image ? (
          <img
            src={image}
            alt="Exhibition"
            style={{ width: "100px", height: "auto" }}
          />
        ) : (
          "No Image"
        ),
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      render: (created_at) => moment(created_at).format("llll"),
    },

    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "8px" }}>
          <Button
            className="bg-warning text-white"
            onClick={() => showUpdateModal(record)}
          >
            <FaEdit />
          </Button>
          <Button
            className="bg-danger text-white"
            onClick={() => showDeleteConfirm(record.exibition_id)}
          >
            <FaTrashAlt />
          </Button>
        </div>
      ),
    },
  ];

  useEffect(() => {
    const dbounce = setTimeout(() => {
      fetchData(pagination.current, pagination.pageSize, searchInput);
    }, 300);

    return () => clearTimeout(dbounce);
  }, [searchInput]);

  const fetchData = async (current, pageSize, search) => {
    setLoading(true);
    try {
      const action = "fetch";
      const response = await get(
        `/exibition.php?limit=${pageSize}&page=${current}&type=blog&action=${action}${
          search ? "&search=" + search + "" : ""
        }`
      );
      setAllQuote(response.list);
      setPagination((prevPagination) => ({
        ...prevPagination,
        current,
        pageSize,
        total: response.total,
      }));
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const showDeleteConfirm = (exibitionId) => {
    confirm({
      title: "Are you sure you want to delete this blog?",
      content: "This action cannot be undone.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: () => handleDelete(exibitionId),
    });
  };

  const handleDelete = async (exhibitionId) => {
    try {
      const formData = new FormData();
      // exibition_id
      formData.append("exibition_id", exhibitionId);
      formData.append("action", "update");
      formData.append("is_active", "0");
      const response = await post("/exibition.php", formData);

      if (response) {
        message.success("Blog deleted successfully");
        fetchData(pagination.current, pagination.pageSize);
      } else {
        message.error("Failed to delete blog");
      }
    } catch (error) {
      console.error(error);
      message.error("An error occurred while deleting the blog");
    }
  };

  const showUpdateModal = (record) => {
    setSelectedExhibition(record);
    updateForm.setFieldsValue({
      title: record.title,
      description: record.description,
      image: record.image,
    });
    setIsUpdateModalVisible(true);
  };

  const handleUpdate = async (values) => {
    try {
      const action = "update";
      const formData = new FormData();
      formData.append("action", action);
      formData.append("user_id", profile.user_id);
      formData.append("exibition_id", selectedExhibition.exibition_id);
      formData.append("title", values.title);
      formData.append("description", values.description);
      formData.append("type", "blog");
      if (values.image && values.image.file) {
        formData.append("image", values.image.file);
      } // Format date
      if (values.image && values.image.file) {
        formData.append("image", values.image.file);
      }

      const response = await post(`/exibition.php`, formData);
      if (response) {
        message.success("Blog updated successfully");
        fetchData(pagination.current, pagination.pageSize);
        setIsUpdateModalVisible(false);
      } else {
        message.error("Failed to update blog");
      }
    } catch (error) {
      console.error(error);
      message.error("An error occurred while updating the blog");
    }
  };

  const handleAdd = async (values) => {
    try {
      const action = "add";
      const formData = new FormData();
      formData.append("action", action);
      formData.append("user_id", profile.user_id);
      formData.append("title", values.title);
      formData.append("description", values.description);
      formData.append("type", "blog");
      if (values.image && values.image.file) {
        formData.append("image", values.image.file);
      }

      const response = await post(`/exibition.php`, formData);
      if (response) {
        message.success("Blog added successfully");
        fetchData(pagination.current, pagination.pageSize);
        addForm.resetFields(); // Reset form fields after successful add
        setIsAddModalVisible(false);
      } else {
        message.error("Failed to add blog");
      }
    } catch (error) {
      console.error(error);
      message.error("An error occurred while adding the blog");
    }
  };

  const handleCancel = () => {
    setIsUpdateModalVisible(false);
  };

  const handleAddCancel = () => {
    setIsAddModalVisible(false);
  };

  const handleTableChange = (newPagination) => {
    const { current, pageSize } = newPagination;

    setPagination({
      ...pagination,
      current,
      pageSize,
    });

    if (pageSize !== pagination.pageSize) {
      fetchData(1, pageSize);
    } else {
      fetchData(current, pageSize);
    }
  };

  return (
    <div className="p-3">
      <div>
        <TitleComp
          name="Blogs List"
          type="Blog"
          totalData={pagination.total}
          button={
            <Button
              className="orderFilter-serach-btn"
              onClick={() => setIsAddModalVisible(true)}
              style={{ marginBottom: "16px" }}
            >
              Add Blog
            </Button>
          }
          setSearchInput={setSearchInput}
        />

        {/* Table for larger screens */}
        <div className="quotation-table">
          <Table
            columns={columns}
            dataSource={allquote}
            pagination={false}
            loading={loading}
            onChange={handleTableChange}
          />
        </div>

        {/* Cards for smaller screens */}
        <div className="quotation-cards">
          {allquote?.map((quote) => (
            <div className="quotation-card" key={quote.exibition_id}>
              {quote.image && (
                <img
                  src={quote.image}
                  alt="Blog"
                  style={{ width: "100px", height: "auto" }}
                />
              )}
              <p>
                <strong>Title:</strong> {quote.title}
              </p>
              <p>
                <strong>Status:</strong> {quote.status}
              </p>
              <p>
                <strong>Created At:</strong>{" "}
                {moment(quote.created_at).format("llll")}
              </p>

              <div style={{ display: "flex", gap: "8px", marginTop: "8px" }}>
                <Button
                  className="bg-warning text-white"
                  onClick={() => showUpdateModal(quote)}
                >
                  <FaEdit />
                </Button>
                <Button
                  className="bg-danger text-white"
                  onClick={() => showDeleteConfirm(quote.exibition_id)}
                >
                  <FaTrashAlt />
                </Button>
              </div>
            </div>
          ))}
        </div>

        <Pagination
          className="mt-4"
          current={pagination.current}
          onChange={(page) =>
            setPagination((prev) => ({ ...prev, current: page }))
          }
          total={pagination.total}
        />
      </div>

      {/* Add Modal */}
      <Modal
        title="Add Blog"
        visible={isAddModalVisible}
        onCancel={handleAddCancel}
        footer={null}
      >
        <Form form={addForm} layout="vertical" onFinish={handleAdd}>
          <div className="row">
            <Form.Item
              label="Title"
              name="title"
              rules={[{ required: true, message: "Please enter the title" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item label="Image" name="image">
              <Upload
                beforeUpload={() => false}
                listType="picture"
                accept=".JPG, .JPEG, .PNG, .WEBP"
              >
                <Button style={{ width: "100%" }} icon={<UploadOutlined />}>
                  Upload Image
                </Button>
              </Upload>
            </Form.Item>
            <Form.Item
              label="Description"
              name="description"
              rules={[
                { required: true, message: "Please enter the description" },
              ]}
              style={{ marginBottom: 70 }}
            >
              <ReactQuill style={{ height: 150 }} />
            </Form.Item>

            <Form.Item>
              <Button className="orderFilter-serach-btn" htmlType="submit">
                Add
              </Button>
              <Button
                type="default"
                onClick={handleAddCancel}
                style={{ marginLeft: "8px" }}
              >
                Cancel
              </Button>
            </Form.Item>
          </div>
        </Form>
      </Modal>

      {/* Update Modal */}
      <Modal
        title="Update Blog"
        visible={isUpdateModalVisible}
        onCancel={handleCancel}
        footer={null}
        centered
      >
        {selectedExhibition && (
          <Form
            form={updateForm}
            layout="vertical"
            initialValues={{
              title: selectedExhibition.title,
              description: selectedExhibition.description,
              status: selectedExhibition.status,
              exibition_date: moment(selectedExhibition.exibition_date), // Convert to moment object
              image: selectedExhibition.image,
            }}
            onFinish={handleUpdate}
          >
            <Form.Item
              label="Title"
              name="title"
              rules={[{ required: true, message: "Please enter the title" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item label="Image" name="image">
              <Upload
                beforeUpload={() => false}
                listType="picture"
                showUploadList={false}
              >
                <Button icon={<UploadOutlined />}>Upload Image</Button>
              </Upload>
              <br />
              {selectedExhibition.image && (
                <img
                  src={selectedExhibition.image}
                  alt="Blog"
                  style={{ width: "100px", height: "auto", marginTop: "8px" }}
                />
              )}
            </Form.Item>

            <Form.Item
              label="Description"
              name="description"
              style={{ marginBottom: 70 }}
              rules={[
                { required: true, message: "Please enter the description" },
              ]}
            >
              <ReactQuill style={{ height: 150 }} />
            </Form.Item>
            <Form.Item>
              <Button className="orderFilter-serach-btn" htmlType="submit">
                Update
              </Button>
              <Button
                type="default"
                onClick={handleCancel}
                style={{ marginLeft: "8px" }}
              >
                Cancel
              </Button>
            </Form.Item>
          </Form>
        )}
      </Modal>
    </div>
  );
};

export default Exhibition;
